var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fillRule":"evenodd","key":2},React.createElement("polygon",{"id":"Path","fillRule":"nonzero","points":"5 12.4 0 7.4 1.4 6 5 9.6 14.6 0 16 1.4"}))]);
}

Check.defaultProps = {"width":"16px","height":"13px","viewBox":"0 0 16 13","version":"1.1"};

module.exports = Check;

Check.default = Check;
